export default "__VITE_ASSET__BdddmtOe__"